"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AGREEMENT_KEYS = exports.DEAL_KEYS = exports.GUARANTOR_KEYS = exports.SIGNER_KEYS = void 0;
exports.signerValues = signerValues;
exports.guarantorValues = guarantorValues;
exports.agreementValues = agreementValues;
/**
 * Signer, guarantor, deal and agreement providers.
 *
 * Unlike the company/customer/finance/equipment providers, these values are
 * supplied per-envelope rather than read from a stored domain record — a
 * signer is chosen when a document is sent, a guarantor is entered at that
 * moment, and an agreement's identifiers belong to the specific document
 * instance being generated.
 */
const nonBlank = (v) => typeof v === 'string' && v.trim().length > 0 ? v.trim() : undefined;
exports.SIGNER_KEYS = ['name', 'email', 'title', 'phone'];
function signerValues(s) {
    return { name: nonBlank(s.name), email: nonBlank(s.email), title: nonBlank(s.title), phone: nonBlank(s.phone) };
}
exports.GUARANTOR_KEYS = ['name', 'address', 'phone', 'email'];
/**
 * PREFILLED, NEVER ASSERTED. A personal guaranty binds someone's own assets, so
 * every value here is confirmed by a human at signing. All four fields declare
 * an `ask` in the catalog; this provider only seeds the form.
 */
function guarantorValues(g) {
    return { name: nonBlank(g.name), address: nonBlank(g.address), phone: nonBlank(g.phone), email: nonBlank(g.email) };
}
exports.DEAL_KEYS = ['name', 'code'];
exports.AGREEMENT_KEYS = [
    'no', 'date', 'effective_date',
    'execution_date', 'execution_time',
    'customer_signed_date', 'company_signed_date', 'guarantor_signed_date',
];
/**
 * The signature keys are undefined at FREEZE and filled only in the executed
 * artifact. They are `source: 'dynamic'` in the catalog and every one declares
 * an `askOf: 'signer'`, which is what keeps them out of the publish gate.
 */
function agreementValues(a) {
    return {
        no: nonBlank(a.agreementNo),
        date: nonBlank(a.agreementDate),
        effective_date: nonBlank(a.effectiveDate),
        execution_date: nonBlank(a.executionDate),
        execution_time: nonBlank(a.executionTime),
        customer_signed_date: nonBlank(a.customerSignedDate),
        company_signed_date: nonBlank(a.companySignedDate),
        guarantor_signed_date: nonBlank(a.guarantorSignedDate),
    };
}
//# sourceMappingURL=party.js.map